// extracted by mini-css-extract-plugin
module.exports = {"Content":"catalogSide_Content__g8bdY","Side":"catalogSide_Side__X1Tnj","Block":"catalogSide_Block__kQFSW"};